/* src/app/builder-screen-beta/event-scripting/simple-mode/template-gallery.component.scss */
.template-gallery {
  padding: 16px 0;
}
.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}
.template-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  position: relative;
}
.template-card:hover {
  border-color: #1890ff;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}
.template-card.template-selected {
  border-color: #1890ff;
  background-color: #e6f7ff;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}
.template-card.template-create-new {
  border-style: dashed;
}
.template-card.template-create-new:hover {
  border-style: solid;
}
.template-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.template-header .template-icon {
  font-size: 24px;
  color: #1890ff;
}
.template-header .template-name {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #262626;
  flex: 1;
}
.template-description {
  margin: 0 0 16px 0;
  font-size: 13px;
  color: #595959;
  line-height: 1.6;
  min-height: 40px;
}
.template-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.template-footer .selected-icon {
  font-size: 20px;
  color: #52c41a;
}
/*# sourceMappingURL=template-gallery.component.css.map */
